<template>
  <el-menu :default-openeds="defaultOpeneds"
           :default-active="defaultActive"
           @select="handleSelect">
    <div class="goCmi"
         v-if="!loginInfo.is_partner">
      <a href="https://cmi.mktindex.com/#/app"
         target="_blank"
         class="fileLink"><img src="../assets/cmi_back.png"
             style="width:22px;height:22px;"> 返回CMI平台</a>
    </div>
    <div class="usage-scenario"
         v-if="lang !== 'en'">
      <a href="https://qmctsz2s8t.feishu.cn/docx/Vx2Udr2JBoDF1Gxb2Wcc3hAOnAd"
         target="_blank"
         class="scenario-content">
        <span class="scenario-text">消费者研究怎么做</span>
      </a>
    </div>
    <!-- <el-submenu index="1">
      <template slot="title"><i class="el-icon-message"></i>导航一</template> -->
    <el-menu-item :index="item.index"
                  v-for="(item) in menueData"
                  @click="routeTo(item.routeName)"
                  :key="item.index"
                  :id="item.index"> <i :class="item.icon"
         class="menue-icon"></i>
      <span slot="title">{{item.label}}</span>
    </el-menu-item>
    <el-submenu index="1-11"
                v-if="!loginInfo.is_partner">
      <template slot="title">
        <i class="iconfont icon-dingzhi"
           style="font-size:16px;margin:0 10px 0 7px;"></i>
        <span>定制服务</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="11-1"
                      id="11-1"
                      style="padding-left:28px!important"
                      @click="showDialog(1)">导入自有数据</el-menu-item>
        <el-menu-item index="11-2"
                      id="11-2"
                      style="padding-left:28px!important"
                      @click="showDialog(2)">消费者体验管理</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <!-- <div class="menuItem"
         v-if="!loginInfo.is_partner"
         @click="showDialog(1)">
      导入自有数据
    </div>
    <div class="menuItem"
         v-if="!loginInfo.is_partner"
         @click="showDialog(2)">
      CEM/消费者体验管理
    </div> -->
    <!-- <div class="menuItem reduce"
         v-if="!loginInfo.is_partner"
         @click="showDialog(3)">
      <i class="iconfont icon-dengpao"
         style="font-size:20px;margin-right: 5px;"></i>
      AI 降本增效
    </div> -->
    <el-dialog :modal-append-to-body="true"
               :append-to-body="true"
               :visible.sync="dialogVisible"
               :show-close="false"
               class="cost-reduce-dialog"
               width="1000px">
      <img src="../assets/import-data.png"
           v-if="dialogType == 1"
           alt=""
           style="width: 100%;height: 100%" />
      <img src="../assets/experience-manage.png"
           v-if="dialogType == 2"
           alt=""
           style="width: 100%;height: 100%" />
      <CostReduce v-if="dialogType == 3" />
    </el-dialog>
    <!-- </el-submenu> -->
  </el-menu>
</template>

<script>
import { parseTime } from '@/utils'
import CostReduce from './CostReduce.vue'
export default {
  name: 'AsideMenue',
  components: {
    CostReduce,
  },
  data() {
    return {
      defaultOpeneds: ['1'], //['1', '3']
      //   defaultActive: '1-1',
      menueData: [
        {
          index: '1-1',
          label: this.$t('menue.find'),
          routeName: 'lifeDiscovery',
          icon: 'iconfont icon-zengchangfaxian',
        },
        {
          index: '1-10',
          label: '拉更多平台来分析',
          routeName: 'fusion',
          icon: 'iconfont icon-lagengduopingtailaifenxi',
        },
        {
          index: '1-2',
          label: this.$t('menue.detail'),
          routeName: 'search',
          icon: 'iconfont icon-sousuo1',
        },
        {
          index: '1-3',
          label: this.$t('menue.porj'),
          routeName: 'loadProject',
          icon: 'iconfont icon-baocun',
        },
        {
          index: '1-4',
          label: this.$t('menue.custom'),
          routeName: 'customManage',
          icon: 'iconfont icon-manage',
        },
        {
          index: '1-5',
          label: this.$t('menue.report'),
          routeName: 'tradeReport',
          icon: 'iconfont icon-baogao-copy',
        },
        {
          index: '1-6',
          label: this.$t('menue.setting'),
          routeName: 'setting',
          icon: 'el-icon-setting',
        },
        // {
        //   index: '1-6',
        //   label: 'selector',
        //   routeName: 'selector',
        //   icon: 'el-icon-setting',
        // },
        // {
        //   index: '1-3',
        //   label: 'home',
        //   routeName: 'Home',
        //   icon: 'el-icon-setting',
        // },
        /*// {
        //   index: '1-3',
        //   label: 'wordcloud',
        //   routeName: 'wordcloud',
        //   icon: 'el-icon-setting',
        // },
        {
          index: '1-4',
          label: 'Echarts',
          routeName: 'Echarts',
          icon: 'el-icon-setting',
        },
        {
          index: '1-5',
          label: 'mixEcharts',
          routeName: 'mixEcharts',
          icon: 'el-icon-setting',
        },
        {
          index: '1-6',
          label: 'selector',
          routeName: 'selector',
          icon: 'el-icon-setting',
        },
        {
          index: '1-7',
          label: 'datatableExample',
          routeName: 'datatableExample',
          icon: 'el-icon-setting',
        },
        // {
        //   index: '1-8',
        //   label: 'DatatableExampleTwo',
        //   routeName: 'DatatableExampleTwo',
        //   icon: 'el-icon-setting',
        // },
        {
          index: '1-9',
          label: 'EchartAndTableExample',
          routeName: 'EchartAndTableExample',
          icon: 'el-icon-setting',
        },*/
      ],
      dialogVisible: false,
      dialogType: '1',
      industryReportsUrl:
        'https://www.mktindex.com/static/industryreports/?f=industryreports',
      lang: localStorage.getItem('language'),
    }
  },
  methods: {
    showDialog(val) {
      this.dialogType = val
      this.$nextTick(() => {
        this.dialogVisible = true
        document.getElementById('11-1').classList.remove('is-active')
        document.getElementById('11-1').blur()
        document.getElementById('11-2').classList.remove('is-active')
        document.getElementById('11-2').blur()
      })
    },
    routeTo(routeName) {
      if (routeName == 'lifeDiscovery') {
        if (window.location.href.indexOf('social.mktindex.com') != -1) {
          window.open(
            'https://chance.mktindex.com/#/social?social_plat=xhs&label=%E8%AF%9D%E9%A2%98'
          )
        } else {
          window.open(
            'https://chancetest.mktindex.com/#/social?social_plat=xhs&label=%E8%AF%9D%E9%A2%98'
          )
        }
        return false
      }
      if (routeName == 'fusion') {
        if (window.location.href.indexOf('social.mktindex.com') != -1) {
          window.open('https://fusion.mktindex.com')
        } else {
          window.open('https://fusiontest.mktindex.com')
        }
        return false
      }
      if (routeName == 'tradeReport') {
        window.open(this.industryReportsUrl, '_blank')
        this.$nextTick(() => {
          document.getElementById('1-5').classList.remove('is-active')
          document.getElementById('1-5').blur()
        })
      } else {
        this.$router.push({
          name: routeName,
        })
      }
    },
    handleSelect(index) {
      if (index == '11-1' || index == '11-2') {
        return
      }
      //   this.$store.dispatch('user/changeActivedMnenue', index)
    },
  },
  computed: {
    defaultActive() {
      // return this.$store.state.user.ActivedMnenue
      let index = '1-1'
      let routeName = this.$route.name,
        matchItem = null
      if (routeName) {
        // index = this.menueData.find((item) => {
        //   return item.routeName == this.$route.name
        // }).index
        matchItem = this.menueData.find((item) => {
          return item.routeName == this.$route.name
        })
        if (matchItem) {
          index = matchItem.index
        }
        if (routeName == 'detail' || routeName == 'lifeDiscovery') {
          index = '1-2'
        }
      }
      return index
    },
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
  },
}
</script>

<style scoped>
.goCmi {
  color: #d9001b;
  padding: 10px 0;
  margin-left: 30px;
}
.fileLink {
  color: #d9001b;
}
.fileLink:hover,
.fileLink:focus {
  text-decoration: unset;
}
.menuItem {
  height: 56px;
  line-height: 56px;
  color: #303133;
  cursor: pointer;
  font-size: 14px;
  margin-left: 30px;
}
.outer-container
  .inner-container
  .inner-aside
  .el-menu
  .el-menu-item
  .menue-icon.iconfont.icon-baocun,
.icon-baogao-copy,
.icon-sousuo1 {
  font-size: 16px !important;
}
.outer-container
  .inner-container
  .inner-aside
  .el-menu
  .el-menu-item
  .menue-icon.iconfont.icon-manage {
  font-size: 20px !important;
}
.reduce {
  color: #3b76f2;
  font-weight: bold;
}
.iconfont {
  display: inline-block;
}
</style>
<style lang="less">
.usage-scenario {
  text-align: center;
  height: 56px;
  line-height: 56px;
  .scenario-content:hover,
  .scenario-content:focus {
    text-decoration: unset;
  }
  .scenario-text {
    font-size: 14px;
  }
}
.cost-reduce-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog {
    border-radius: 5px;
  }
  .el-dialog__body {
    padding: 0;
    border-radius: 5px;
  }
}
</style>